<!-- ai-assistant.component.html -->
<div class="chat-page">
	<div class="chat-container">
		<div class="chat-wrapper scrollable" #chatScroll>
			<div class="chat-title">
				<img src="/assets/img/Aclarian_swoop_4C_FULL.png" class="mobile-hide" style="width: 150px" />
				Andi
			</div>

			<!-- EN-4448: role framing so users know which assistant they are talking to. The Claire
			     pointer only renders for clients whose PortalAgent flag exposes Claire. -->
			<div class="assistant-intro">
				<div class="assistant-intro-role">I answer how-to and documentation questions about using Aclarian.</div>
				<div class="assistant-intro-claire" *ngIf="claireEnabled">
					Need to look up data or take action, like drafting a check request or checking a budget? Ask
					<a routerLink="/claire">Claire</a>, your ERP agent.
				</div>
			</div>

			<div
				*ngFor="let msg of messages"
				[ngClass]="{ 'message-row': true, left: msg.role === 'assistant', right: msg.role === 'user' }"
			>
				<div *ngIf="msg.role === 'user'" class="user-question">
					<div class="q-label">{{ userName }}</div>
					<div class="q-text">{{ msg.content }}</div>
					<div class="q-time">{{ msg.timestamp | date : 'short' }}</div>
				</div>

				<div *ngIf="msg.role === 'assistant'" class="ai-answer-block">
					<div class="answer-header">
						<!--<span class="material-icons">menu_book</span>-->
						<span class="label"><img class="answer-avatar" src="assets/img/andi/andi-avatar.png" alt="" /> Andi</span>
					</div>

					<div class="answer-content">
						<ng-container *ngIf="msg.typing; else finalAnswer">
							<div [innerHTML]="msg.safeDisplayContent"></div>
						</ng-container>
						<ng-template #finalAnswer>
							<div [innerHTML]="msg.safeContent"></div>
						</ng-template>
					</div>
				</div>
			</div>
			<div *ngIf="isLoading" class="message-row left">
				<div class="ai-answer-block typing">
					<div class="answer-header">
						<span class="label"><img class="answer-avatar" src="assets/img/andi/andi-avatar.png" alt="" /> Andi</span>
					</div>
					<div class="reading-book">
						<span class="material-icons">menu_book</span>
					</div>
					<div class="typing-indicator"><span></span><span></span><span></span></div>
				</div>
			</div>
		</div>

		<!-- Chat Input (fixed to bottom) -->
		<div class="chat-input-container pinned chat-wrapper">
			<textarea
				class="chat-input"
				[(ngModel)]="userInput"
				placeholder="Ask me anything about Aclarian..."
				rows="2"
				(keydown.enter)="sendMessage()"
			></textarea>
			<div class="chat-input-footer">
				<span class="char-count">{{ charCount }}</span>
				<button class="send-btn" (click)="sendMessage()" [disabled]="isLoading">
					<span class="material-icons">send</span>
				</button>
			</div>
		</div>
	</div>
</div>
